import React from 'react';
import { useDispatch } from 'react-redux';
import { setModalOpen, setModalType, setCurrentPage, setTemplateType } from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid } from '@mui/material';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
function AddResponseTemplateSuccess() {
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setCurrentPage, currentPage: 1 });
        dispatch({ type: setTemplateType, templateType: 'published' });
    };
    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="response-template" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Template saved
                </Typography>
                {/* <Typography variant="p" component="p">
                    You have successfully saved this template. Now you can view the performance on this post.
                </Typography> */}
            </Box>

            <Box className="modal-footer pt-0">
                <Grid container rowSpacing={3}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            className="alternate-reversed w-full"
                            onClick={() => dispatch({ type: setModalType, modalType: 'add' })}
                        >
                            Make new template
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" className="alternate-reversed w-full" onClick={handleClose}>
                            Back to all templates
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default AddResponseTemplateSuccess;
